import React, { useEffect, useState } from "react";

import { renderTextField } from "../formcomponents";
import { Grid, Label, Tab } from "semantic-ui-react";
import FileListUpload from "./FileListUpload";
import axios from "axios";
import { BaseUrl } from "../formcomponents/Constants";
import NewCompanyForm from "./NewCompanyForm";

const NewCompany = (props) => {
  const { userId } = props;
  const [companyData, setcompanyData] = useState("");
  useEffect(() => {
    console.log("userId", userId);
    getCompanyList();
  }, []);
  const [companyDetailList, setcompanyDetailList] = useState([]);
  const getCompanyList = () => {
    axios
      .get(BaseUrl + "listCompany")
      .then((res) => {
        let values = [...companyDetailList];
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].userId == userId) {
            values.push(res.data[i]);
          }
        }
        setcompanyDetailList(values);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const panes = companyDetailList.map((item, index) => ({
    menuItem: `Company-${index + 1}`,
    render: () => (
      <Tab.Pane attached={false}>
        <NewCompanyForm
          companyDetailList={companyDetailList[index]}
          indexVal={index}
        />
      </Tab.Pane>
    ),
  }));

  // const panes2 = [
  //   {
  //     menuItem: "Tab 1",
  //     render: () => (
  //       <Tab.Pane>
  //         <NewCompanyForm />
  //       </Tab.Pane>
  //     ),
  //   },
  // ];

  return (
    <div>
      <Tab
        menu={{ borderless: true, attached: false, tabular: false }}
        panes={panes}
      />
    </div>
  );
};

export default NewCompany;
